import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import StockMovementService from '../services/StockMovementService';

const initialState = {
    datas: [],
    pagination: {},
    data: null,
    loading: false,
    error: null,
    isSuccess: false,
    submitLoading: false,
};

export const fetchStockMovements = createAsyncThunk(
    'stockMovement/fetchAll',
    async (params, { rejectWithValue }) => {
        try {
            const resp = await StockMovementService.List(params);
            return resp;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const fetchStockMovementById = createAsyncThunk(
    'stockMovement/fetchById',
    async (id, { rejectWithValue }) => {
        try {
            const resp = await StockMovementService.Show(id);
            return resp.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const confirmStockMovement = createAsyncThunk(
    'stockMovement/confirm',
    async (id, { rejectWithValue }) => {
        try {
            const resp = await StockMovementService.Confirm(id);
            return resp.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const stockMovementSlice = createSlice({
    name: 'stockMovement',
    initialState,
    reducers: {
        resetState: (state) => {
            state.data = null;
            state.loading = false;
            state.error = null;
            state.isSuccess = false;
            state.submitLoading = false;
        },
    },
    extraReducers: (builder) => {
        builder
            // Fetch All
            .addCase(fetchStockMovements.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchStockMovements.fulfilled, (state, action) => {
                state.loading = false;
                state.datas = action.payload.data.data.stockMovementList;
                state.pagination = action.payload.data.data.pagination;
            })
            .addCase(fetchStockMovements.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Fetch By Id
            .addCase(fetchStockMovementById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchStockMovementById.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload.data;
            })
            .addCase(fetchStockMovementById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Confirm
            .addCase(confirmStockMovement.pending, (state) => {
                state.submitLoading = true;
            })
            .addCase(confirmStockMovement.fulfilled, (state, action) => {
                state.submitLoading = false;
                state.isSuccess = true;
                toast.success(action.payload?.message || 'Stock Movement confirmed successfully');
            })
            .addCase(confirmStockMovement.rejected, (state, action) => {
                state.submitLoading = false;
                state.error = action.payload;
                toast.error(action.payload?.message || 'Failed to confirm Stock Movement');
            });
    },
});

export const { resetState } = stockMovementSlice.actions;
export const stockMovementSelector = (state) => state.stockMovement;
export default stockMovementSlice.reducer;
